export function getBrowserInfo() {
	const userAgent = navigator.userAgent;
	let browserName = "unknown";
	let browserVersion = "unknown";

	if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) {
		browserName = "chrome";
		const match = userAgent.match(/Chrome\/(\d+)/);
		if (match && match[1]) {
			browserVersion = match[1];
		}
	} else if (userAgent.includes("Firefox")) {
		browserName = "firefox";
		const match = userAgent.match(/Firefox\/(\d+)/);
		if (match && match[1]) {
			browserVersion = match[1];
		}
	} else if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) {
		browserName = "safari";
		const match = userAgent.match(/Version\/(\d+)/);
		if (match && match[1]) {
			browserVersion = match[1];
		}
	} else if (userAgent.includes("Edg")) {
		browserName = "edge";
		const match = userAgent.match(/Edg\/(\d+)/);
		if (match && match[1]) {
			browserVersion = match[1];
		}
	} else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
		browserName = "opera";
		const match = userAgent.match(/(Opera|OPR)\/(\d+)/);
		if (match && match[2]) {
			browserVersion = match[2];
		}
	} else if (userAgent.includes("MSIE") || userAgent.includes("Trident")) {
		browserName = "internet_explorer";
		const match = userAgent.match(/(MSIE |rv:)(\d+)/);
		if (match && match[2]) {
			browserVersion = match[2];
		}
	}

	return {
		name: browserName,
		version: browserVersion,
	};
}